import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ViewDetailIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 2C5.34315 2 4 3.34315 4 5V19C4 20.6569 5.34315 22 7 22H10C10.5523 22 11 21.5523 11 21C11 20.4477 10.5523 20 10 20H7C6.44772 20 6 19.5523 6 19V5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12V5C20 3.34315 18.6569 2 17 2H7Z"
      fill="currentColor"
    />
    <path
      d="M9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H9Z"
      fill="currentColor"
    />
    <path
      d="M9 10C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12H12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10H9Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M15.2887 13.5C13.19 13.5 11.4887 15.2013 11.4887 17.3C11.4887 19.3987 13.19 21.1 15.2887 21.1C15.975 21.1 16.6187 20.9181 17.1744 20.5999L18.2816 21.7071C18.6721 22.0976 19.3053 22.0976 19.6958 21.7071C20.0863 21.3166 20.0863 20.6834 19.6958 20.2929L18.5886 19.1857C18.9068 18.63 19.0887 17.9862 19.0887 17.3C19.0887 15.2013 17.3874 13.5 15.2887 13.5ZM13.4887 17.3C13.4887 16.3059 14.2946 15.5 15.2887 15.5C16.2828 15.5 17.0887 16.3059 17.0887 17.3C17.0887 18.2941 16.2828 19.1 15.2887 19.1C14.2946 19.1 13.4887 18.2941 13.4887 17.3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

ViewDetailIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ViewDetailIcon);
